import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DS_DEMO_DNA2_3 = {
  title: `The AI-powered system provides him \nwith a profiling report on data available in \nthe raw zone, <span style="color: #92D1FF;">  highlighting Data Quality \n(DQ) aspects for his review.</span>`,
  subtitle: "Data STREAMS demo",
  label: [{ iconPath: "start.png", text: "AI-first Innovation" }],
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(208),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(206),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA2/DNA2_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "DNA2/DNA2_DS_DEMO_03_computer.png",
          imageStyle: {
            position: "absolute",
            right: "73.59px",
            bottom: "255.58px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_03_alert.png",
          imageStyle: { position: "absolute", right: "351px", bottom: "158px" },
        },
        {
          image: "DNA2/DNA2_DS_DEMO_03_eye.png",
          imageStyle: {
            position: "absolute",
            right: "264px",
            bottom: "57px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA2/DNA2_DS_DEMO_03_check.png",
          imageStyle: {
            position: "absolute",
            right: "125px",
            bottom: "769px",
          },
        },
      ]}
      pageNumber={207}
    />
  ),
};
